import React, {useEffect} from "react";
import AOS from "aos";
import "aos/dist/aos.css"; 
import styles from './styles/whyJoinUs.module.css'
import Card from "../../reusableComponents/cardComponent/Card";
import viewerimg1 from '../../../assets/images/viewers1.png';
import viewerimg2 from '../../../assets/images/viewers2.png';
import viewerimg3 from '../../../assets/images/viewers3.png';
import teamsimg1 from '../../../assets/images/teams1.png';
import teamsimg2 from '../../../assets/images/teams2.png';
import teamsimg3 from '../../../assets/images/teams3.png';
import bgimage from '../../../assets/images/whyjoinusbgimage.png';
import ellipseImage1 from '../../../assets/images/Ellipse.png';
import ellipseImage2 from '../../../assets/images/Ellipse2.png';
import ellipseImage3 from '../../../assets/images/Ellipse3.png';

const viewersData = [
  {
    image: viewerimg1,
    description: "Experience the thrill of live dance battles from the comfort of your home.",
  },
  {
    image: viewerimg2,
    description: "Vote for your favorite teams and cheer them onto victory.",
  },
  {
    image: viewerimg3,
    description: "Access exclusive dance content and behind-the-scenes action through Beats Fusion Premium.",
  },
];

const teamsData = [
  {
    image: teamsimg1,
    description: "Showcase your talent on a premier platform and gain nationwide recognition.",
  },
  {
    image: teamsimg2,
    description: "Connect with fans and build a dedicated following.",
  },
  {
    image: teamsimg3,
    description: "Compete for prizes and opportunities to elevate your dance career more text even more text.",
  },
];

const WhyJoinUs: React.FC = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <div 
      id="benefits" className={`${styles.negativeMargin} ${styles.grid} w-9/12 mx-auto py-0 sm:py-16 relative bg-cover bg-center`}
      style={{
        backgroundImage: `url(${bgimage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '80%',
      }}
    >
      <div
        className={`hidden sm:block absolute top-0 right-0 z-0 ${styles.hideEllipses}`}
        style={{
          backgroundImage: `url(${ellipseImage1})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          width: '200px',
          height: '200px', 
          transform: 'translate(90%, 30%)', 
        }}
      ></div>

      <div
          className={`hidden sm:block absolute bottom-0 right-0 z-0 ${styles.hideEllipses}`}
          style={{
          backgroundImage: `url(${ellipseImage2})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          width: '200px', 
          height: '200px',
          transform: 'translate(85%, 57.2%)', 
          }}
      ></div>

      <div
          className={`hidden sm:block absolute bottom-0 left-0 z-0 ${styles.hideEllipses}`}
          style={{
          backgroundImage: `url(${ellipseImage3})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          width: '150px',
          height: '150px',
          transform: 'translate(-120%, 12%)', 
          }}
      ></div>

      <h2 data-aos="fade-down" className={` text-4xl sm:text-4xl md:text-5xl lg:text-7xl font-semibold text-center text-black mt-60 relative z-10 ${styles.header_text}`}>
        Why you should join us
      </h2>
      <p data-aos="fade-down" className="text-center text-md sm:text-base text-black mt-5 sm:mt-2 relative z-10">
        Either as a team or viewer looking to feed your eyes with captivating dance? Beats Fusion got you.
      </p>

      <div className="mt-14 sm:mt-16 relative z-10">
        <h3 className="text-3xl font-semibold text-black mb-6 text-center">Viewers</h3>
        <div  data-aos="fade-up" className={`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 sm:gap-16 ${styles.images_container}`}>
          {viewersData.map((viewer, index) => (
            <Card
              key={index}
              image={viewer.image}
              description={viewer.description}
            />
          ))}
        </div>
      </div>

      <div className="mt-20 relative z-10">
        <h3 className="text-3xl font-semibold text-black mb-6 text-center">Teams</h3>
        <div data-aos="fade-up" className={`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 sm:gap-16 ${styles.images_container}`}>
          {teamsData.map((team, index) => (
            <Card
              key={index}
              image={team.image}
              description={team.description}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhyJoinUs;
